module.exports = __webpack_public_path__ + "static/img/top_gf2.74a9bad1.png";